import React, { Fragment, useState, useEffect } from 'react'
import { Card, Col, Input, Row, Media, Table, FormGroup, CardBody, CardHeader } from 'reactstrap'
import ApexCharts from 'react-apexcharts'
import { useBankingDeposits } from '../../hooks/reports/useBankingDeposits'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { ModalAutorizationInvoices } from './ModalAutorizationInvoices';
import { cedimi } from '../../constant/globalConstantsTypeClients';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Chart } from 'primereact/chart';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primeicons/primeicons.css';
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from 'primereact/tabview';
import { TabMenu } from 'primereact/tabmenu';
import { Tag } from 'primereact/tag';
import { IndexPatientCredit } from './IndexPatientCredit';








export const IndexBankingDeposits = () => {


  const {
    // ? REPORT BANKING
    start_date, end_date, handleInputChange, listMovements, indicatorPatient, indicatorAmountInvoice,
    listMovementsInvoice, saveReceived, disabledSaveButton,

    // ? FORMVALUES DEPOSITS
    received, delivere, amount, observation, date_1, date_2, one, range, number_format, validationsSG, GetDeposits,
    totalDepositSend, listDetailBranch, arrayDeposits,
    modalAutorization, toggleModalAutorization, handleInvoices, handleSelecUser, handleSelectPassword, validatePassword, loadingServices, username,

    // ? ONCHANGE CALENDER
    date, onChange, validNotification, tileClassName, handleActions, _validationFinance, detailBranch,

    // ? VIEW CREDIT, FULLY PAID
    type_action,

    // ? DETAIL PAYMENT COMPLEMENT
    dataComplement, totalComplement, isComplement,
    invoiceBranch, monthInvoices, handleSelectBranch, handleSelectMonth, handleSelectAge, getInformationInvoices, listInvoices,
    checkedItems, selectAll, handleCheckboxChange, handleSelectAllChange, saveInvoices,

    // ? CORTESY
    dataCortesy, handleReport, companyInfo, formatter, navigateNim, countPatient, cancellPatient,
    valid_view, loadingDeposits, _cliente,

    // ? REPORT DISCOUNT
    headerTemplate, paymentBodyTemplate, reportDiscounts, chartData, countDiscount, exportToExcelDiscount,
    setGlobalFilter, globalFilter, downloadChart, chartRef, loadingDiscount, visible, showModal, hideModal,

    // ? REPORT BONUS
    reportBonus, visibleBonus, showModalBonus, hideModalBonus, countBonus, chartDataBonus, chartOptionsBonus,
    chartBonustRef, handleDownload, setGlobalBonusFilter, globalBonusFilter, exportToExcelBonus,

    // ? REPORT CANCELL
    exportToExcelCancell, formattedData, visibleCancell, showModalCancel, hideModalCancel, setGlobalCancellFilter, globalCancellFilter,
    chartDataCancell, chartOptionsCancell, handleCancellDownload, chartCancellRef,

    // ? REPORT DEVOLUTION
    chartDataDevolution, chartOptionsDevolution, countDevolution, devolutionPatient, visibleDevolution, showModalDevolution, hideModalDevolution,
    exportToExcelDevolution, chartDevolutionRef, handleDevolutionDownload, globalDevolutionFilter, setGlobalDevolutionFilter, loading,

    // ? REPORT BANKING AND MEMBRESIA
    showModalBanking, hideModalBanking, visibleBanking, showModalMembresia, hideModalMembresia, visibleMembresia,
    chartDataReason, chartOptionsReason, groupedByReason,
    _active_micro, amountSanitary, _valid_Finance, handleClosedView,
    modalviewPayment, togglePayment, handlePayment,
    activeView, requestChangeType, dataInvoicePending, loadingPending, setActiveView, activeIndex, setActiveIndex,
    getInformationInvoices2, loadingInvoice



  } = useBankingDeposits();
  console.log("🚀 ~ IndexBankingDeposits ~ dataInvoicePending:", dataInvoicePending)


  console.log("🚀 ~ IndexBankingDeposits ~ listInvoices:", listInvoices.length)

  //!TOTAL PRICE
  const [totalCollected, setTotalCollected] = useState(0);
  const [totalGlobal, setTotalGlobal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);


  const formatAmount = (amount) => {
    return amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const customBody = (rowData) => {
    return (
      <div
        style={{
          border: "2px solid orange",
          borderRadius: "12px",
          // padding: "1px 4px",
          cursor: "pointer",
          textAlign: "center",
          backgroundColor: "#f8f8f8",
          fontWeight: "bold",
          fontSize: "10px"
        }}
      >
        {rowData.nim}
      </div>
    );
  };

  useEffect(() => {
    const calculateTotals = () => {
      let collected = 0;
      let global = 0;

      detailBranch.flatMap((_branch) =>
        _branch.children.map((_child) => {
          const branchDetails = _child.id && listDetailBranch[_child.id]
            ? listDetailBranch[_child.id].filter(_detail => _detail.id_branch === _child.id && _detail.id_pay_method === 1)
            : [];

          const detail = branchDetails.length > 0 ? branchDetails[0] : null;
          const total = detail ? (detail.amount - _child.amount_collected) : 0;

          collected += _child.amount_collected;
          global += total;

          return _child;
        })
      );

      setTotalCollected(collected);
      setTotalGlobal(global);
    };


    calculateTotals();
  }, [detailBranch, listDetailBranch]);


  useEffect(() => {
    let sum = 0;

    if (listMovements !== null) {
      listMovements.forEach(element => {
        if (element?.id_pay_method === 29 || element.id_pay_method === 31 || element.id_pay_method === 7) {
          return;
        }

        sum += element.amount;
      });

      setTotalAmount(sum);
    }
  }, [listMovements])

  const paymentMethods = {
    1: "Efectivo",
    2: "Tarjeta de Credito",
    4: "Tarjeta de Débito",
    8: "Transferencia electronica",
    0: "Otro"
  };

  const filteredInvoices = selectedPaymentMethod
    ? listInvoices.filter(invoice => {
      const payMethod = Array.isArray(invoice.pay_methods) ? invoice.pay_methods[0] : invoice.pay_methods;
      return payMethod === selectedPaymentMethod;
    })
    : listInvoices;


  const filteredInvoicess = selectedPaymentMethod
    ? dataInvoicePending.filter(invoice => {
      const payMethod = Array.isArray(invoice.pay_methods) ? invoice.pay_methods[0] : invoice.pay_methods;
      return payMethod === selectedPaymentMethod;
    })
    : dataInvoicePending;

  const totalAmount2 = filteredInvoices.reduce((sum, invoice) => sum + (invoice.amount ?? 0), 0);

  const invoicesAmount2 = (
    <tr style={{ backgroundColor: 'rgb(1 12 18)', height: '20px' }} className='sticky-footer'>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td className='label-finance'>Totales Globales:</td>
      <td className='label-finance'>
        ${number_format(totalAmount2 ?? 0, 2)}
      </td>

    </tr>
  );


  // ? CHART   ------new 
  const paymentMethods2 = {};

  filteredInvoices.forEach(invoice => {
    const payMethod = Array.isArray(invoice?.pay_methods) ? invoice?.pay_methods[0] : invoice?.pay_methods;
    let methodName;

    switch (payMethod) {
      case 1:
        methodName = 'Efectivo';
        break;
      case 2:
        methodName = 'Tarjeta de Crédito';
        break;
      case 4:
        methodName = 'Tarjeta de Débito';
        break;
      case 8:
        methodName = 'Transferencia Electrónica';
        break;
      case 10:
        methodName = 'Crédito';
        break;
      case 27:
        methodName = 'Método PPD';
        break;
      default:
        methodName = 'Mercado Pago';
        break;
    }

    paymentMethods2[methodName] = (paymentMethods2[methodName] || 0) + invoice.amount;
  });

  const labels = Object.keys(paymentMethods2);

  const chartOptions = {
    chart: {
      type: 'donut',
      height: 350,
    },
    labels: labels,
    plotOptions: {
      pie: {
        donut: {
          size: '60%',
          total: {
            show: false,
          },
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `$${val.toLocaleString()}`,
      },
      style: {
        fontSize: '12px',
        fontFamily: 'Arial, sans-serif',
      },
    },
    fill: {
      colors: ['#FFC107', '#0079C7', '#07e357', '#f55463', '#D0E6A5', '#FFC107'],
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: '100%',
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
    dataLabels: {
      enabled: false,
    },
  };

  var _ticket = number_format(totalAmount / indicatorPatient, 2)

  // ? CONFIGURATION TOTAL AMOUNT SERVICE THE AMOUNT 
  const leftContents = (
    <div className="finance-summary">

      <div className="finance-summary-item primary">
        <span className="finance-summary-label">
          Ingreso Total
        </span>

        <span className="finance-summary-value">
          {_valid_Finance === "True"
            ? `$${number_format(totalAmount - totalCollected, 2)}`
            : `$${number_format(totalAmount, 2)}`
          }
        </span>
      </div>


      <div className="finance-summary-item info">
        <span className="finance-summary-label">
          Total en cuenta
        </span>

        <span className="finance-summary-value">
          ${number_format(totalDepositSend, 2)}
        </span>
      </div>


      {_valid_Finance !== "True" && (
        <div className="finance-summary-item success">
          <span className="finance-summary-label">
            Ticket promedio
          </span>

          <span className="finance-summary-value">
            ${_ticket}
          </span>
        </div>
      )}


      <button
        type="button"
        className="finance-summary-item danger finance-summary-clickable"
        disabled={loadingDiscount}
        onClick={showModal}
      >
        <span className="finance-summary-label">
          Descuentos
        </span>

        <span className="finance-summary-value">
          {loadingDiscount ? (
            <i
              className="pi pi-spin pi-spinner"
              style={{ fontSize: "1rem" }}
            />
          ) : (
            `$${countDiscount}`
          )}
        </span>
      </button>


      {_cliente === cedimi && (
        <button
          type="button"
          className="finance-summary-item danger finance-summary-clickable"
          onClick={showModalBonus}
        >
          <span className="finance-summary-label">
            Bonificaciones
          </span>

          <span className="finance-summary-value">
            ${countBonus}
          </span>
        </button>
      )}


      <button
        type="button"
        className="finance-summary-item warning finance-summary-clickable"
        onClick={showModalDevolution}
      >
        <span className="finance-summary-label">
          Devoluciones
        </span>

        <span className="finance-summary-value">
          ${countDevolution}
        </span>
      </button>


      {_active_micro === "True" && _cliente !== cedimi && (
        <>
          <button
            type="button"
            className="finance-summary-item secondary finance-summary-clickable"
            onClick={showModalBonus}
          >
            <span className="finance-summary-label">
              Total Microsanitaria
            </span>

            <span className="finance-summary-value">
              ${amountSanitary}
            </span>
          </button>

          <button
            type="button"
            className="finance-summary-item primary finance-summary-clickable"
            onClick={showModalBonus}
          >
            <span className="finance-summary-label">
              Total Clínicos
            </span>

            <span className="finance-summary-value">
              $
              {(
                (typeof totalAmount === "string"
                  ? parseFloat(totalAmount.replace(/,/g, ""))
                  : totalAmount) -
                (typeof amountSanitary === "string"
                  ? parseFloat(amountSanitary.replace(/,/g, ""))
                  : amountSanitary)
              ).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
            </span>
          </button>
        </>
      )}

    </div>
  );

  // ? MENU
  const items =
    [
      { label: 'Dashboard', icon: 'pi pi-chart-bar' },
      { label: 'Deposito Bancario', icon: 'pi pi-id-card' },
      { label: 'Pendientes a facturar', icon: 'pi pi-file-pdf' },
    ]

  // * STYLES DATA TABLE
  const headerStyle = {
    backgroundColor: "#1d5b83",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "10px",
    borderRight: "1px solid #fff",
    borderBottom: "2px solid #fff",
  };

  const cellStyle = {
    fontSize: "10px",
    padding: "5px",
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",

  };

  const centerStyle = {
    ...cellStyle,
    textAlign: "center",
    zIndex: 2
  };

  // ? CONFIGURATION TAG
  const tagInfo = (rowData) => {
    if (rowData.uuid === null) {
      return <Tag style={{ backgroundColor: "#f8d62b", width: "82px", fontSize: "10px", }} className="mr-2" value={rowData.folio}  ></Tag>;
    }
    return <Tag className="mr-2 " style={{ width: "82px", fontSize: "10px", }} severity='secondary' value={rowData.folio}   ></Tag>;
  };

  // ? CONFIGURATION TAG INVOICE
  const tagInfoInvoice = (rowData) => {
    if (rowData.uuid === null) {
      return <Tag style={{ backgroundColor: "#f8d62b", width: "82px", fontSize: "10px", }} className="mr-2" value={rowData.folioReceptor}  ></Tag>;
    }
    return <Tag className="mr-2 " style={{ width: "82px", fontSize: "10px", }} severity='secondary' value={rowData.folioReceptor}   ></Tag>;
  };

  // ? CONFIGURATION AMOUNT COMPLEMENT
  const SumTotal = dataComplement.reduce((acc, r) => acc + (r.payment_amount ?? 0), 0);

  const footerStyle =
  {
    backgroundColor: '#000',
    color: '#fff',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '0.75rem',
    padding: '4px',
  };

  const colors = [
    "#2e7d32",
    "#ef6c00",
    "#ff8282",
    "#5d4037",
    "#3949ab",
    "#00897b",
    "#00dd0b",
    "#00118fa1",
    "#c62828",
    "#5d4037",
    "#828ede",
    "#ff824c"
  ];

  const icons = [
    "fa fa-building"
  ];

  const getBranchStyle = (idBranch) => ({
    color: colors[idBranch % colors.length],
    background: `${colors[idBranch % colors.length]}20`,
    icon: icons[idBranch % icons.length]
  });


  const getPayMethodInfo = (id) => {
    switch (id) {
      case 1:
        return {
          name: "Efectivo",
          icon: "fa fa-money",
          color: "#2e7d32",
          background: "#e8f5e9"
        };

      case 2:
        return {
          name: "Tarjeta de Crédito",
          icon: "fa fa-credit-card",
          color: "#1565c0",
          background: "#e3f2fd"
        };

      case 4:
        return {
          name: "Tarjeta de Débito",
          icon: "fa fa-credit-card",
          color: "#6a1b9a",
          background: "#f3e5f5"
        };

      case 8:
        return {
          name: "Transferencia Electrónica",
          icon: "fa fa-exchange",
          color: "#ef6c00",
          background: "#fff3e0"
        };

      case 10:
        return {
          name: "Crédito",
          icon: "fa fa-handshake-o",
          color: "#00838f",
          background: "#e0f7fa"
        };

      case 27:
        return {
          name: "Método PPD",
          icon: "fa fa-file-text-o",
          color: "#5d4037",
          background: "#efebe9"
        };

      case 31:
        return {
          name: "Bonificación",
          icon: "fa fa-gift",
          color: "#c62828",
          background: "#ffebee"
        };

      case 7:
        return {
          name: "Cheque nominativo",
          icon: "fa fa-money",
          color: "#455a64",
          background: "#eceff1"
        };

      default:
        return {
          name: "Mercado Pago",
          icon: "fa fa-shopping-cart",
          color: "#009ee3",
          background: "#e1f5fe"
        };
    }
  };


  // * GET MOVEMENTS
  const getMovementAmount = (idPayMethod) => {
    return (listMovements || [])
      .filter(
        item =>
          item?.id_pay_method === idPayMethod &&
          item?.amount !== null &&
          item?.amount !== undefined
      )
      .reduce(
        (acc, item) => acc + Number(item?.amount ?? 0),
        0
      );
  };


  const getInvoiceMovementAmount = (idPayMethod) => {
    return (listMovementsInvoice || [])
      .filter(
        item =>
          item?.id_pay_method === idPayMethod &&
          item?.amount !== null &&
          item?.amount !== undefined
      )
      .reduce(
        (acc, item) => acc + Number(item?.amount ?? 0),
        0
      );
  };


  const hasPaymentMethod = (idPayMethod) => {
    return (
      (listMovements || []).some(
        item =>
          item?.id_pay_method === idPayMethod &&
          item?.amount !== null &&
          item?.amount !== undefined
      ) ||
      (listMovementsInvoice || []).some(
        item =>
          item?.id_pay_method === idPayMethod &&
          item?.amount !== null &&
          item?.amount !== undefined
      )
    );
  };


  // * PAYMENTS
  const paymentCards = [
    {
      id: 1,
      title: "Efectivo",
      abbreviation: "E",
      icon: "fa fa-money",

      amount:
        _valid_Finance === "True"
          ? (
            detailBranch?.length === 0
              ? getMovementAmount(1)
              : totalGlobal
          )
          : getMovementAmount(1),

      invoiceAmount: getInvoiceMovementAmount(1)
    },

    {
      id: 10,
      title: "Crédito",
      abbreviation: "C",
      icon: "fa fa-credit-card",

      amount:
        _validationFinance === true ||
          _validationFinance === "True"
          ? totalGlobal
          : getMovementAmount(10),

      invoiceAmount: getInvoiceMovementAmount(10),

      onClick: () => handleReport()
    },

    {
      id: 2,
      title: "Tarjeta de crédito",
      abbreviation: "T.C",
      icon: "fa fa-credit-card",

      amount: getMovementAmount(2),

      invoiceAmount: getInvoiceMovementAmount(2)
    },

    {
      id: 4,
      title: "Tarjeta de débito",
      abbreviation: "T.D",
      icon: "fa fa-credit-card-alt",

      amount: getMovementAmount(4),

      invoiceAmount: getInvoiceMovementAmount(4)
    },

    {
      id: 8,
      title: "Transferencia",
      abbreviation: "T.E",
      icon: "fa fa-exchange",

      amount: getMovementAmount(8),

      invoiceAmount: getInvoiceMovementAmount(8)
    },

    {
      id: 28,
      title: "Fondo / Depósito",
      abbreviation: "F.D",
      icon: "fa fa-bank",

      amount: getMovementAmount(28),

      invoiceAmount: getInvoiceMovementAmount(28)
    },

    {
      id: 7,
      title: "Cheque",
      abbreviation: "CH",
      icon: "fa fa-file-text-o",

      amount: getMovementAmount(7),

      invoiceAmount: getInvoiceMovementAmount(7)
    }

  ].filter(item => hasPaymentMethod(item.id));



  const totalBankDeposits = (arrayDeposits || []).reduce(
    (acc, item) =>
      acc + Number(item?.amount ?? 0),
    0
  );


  const totalMembership = (dataCortesy || []).reduce(
    (acc, item) =>
      acc + Number(item?.amount ?? 0),
    0
  );


  // *  CHART
  const paymentAreaChart = {
    series: [
      {
        name: "Ingreso",
        data: paymentCards.map(item =>
          Number(item.amount || 0)
        )
      },
      {
        name: "Facturado",
        data: paymentCards.map(item =>
          Number(item.invoiceAmount || 0)
        )
      }
    ],

    options: {
      chart: {
        type: "area",

        toolbar: {
          show: false
        },

        zoom: {
          enabled: false
        },

        parentHeightOffset: 0,

        animations: {
          enabled: true,
          easing: "easeinout",
          speed: 650
        },

        fontFamily: "inherit",
        foreColor: "#74889a",

        dropShadow: {
          enabled: true,
          top: 4,
          left: 0,
          blur: 5,
          opacity: 0.08
        }
      },

      colors: [
        "#20A6DF",
        "#EF4055"
      ],

      dataLabels: {
        enabled: false
      },

      stroke: {
        curve: "smooth",
        width: [3, 3],
        lineCap: "round"
      },

      markers: {
        size: 4,
        strokeWidth: 3,
        strokeColors: "#ffffff",

        hover: {
          size: 7
        }
      },

      fill: {
        type: "gradient",

        gradient: {
          shadeIntensity: 0.15,
          opacityFrom: 0.22,
          opacityTo: 0.01,
          stops: [0, 80, 100]
        }
      },

      grid: {
        show: true,
        borderColor: "#edf2f6",
        strokeDashArray: 4,

        padding: {
          top: 0,
          right: 15,
          bottom: -25,
          left: 10
        }
      },

      legend: {
        show: true,
        position: "top",
        horizontalAlign: "left",

        offsetY: -4,

        fontSize: "11px",
        fontWeight: 500,

        markers: {
          width: 9,
          height: 9,
          radius: 9
        },

        itemMargin: {
          horizontal: 10,
          vertical: 0
        }
      },


      xaxis: {
        categories: paymentCards.map(
          item => item.abbreviation
        ),

        axisBorder: {
          show: true,
          color: "#dce5ec",
          height: 1
        },

        axisTicks: {
          show: false
        },

        labels: {
          show: true,

          style: {
            colors: "#7d91a3",
            fontSize: "9px",
            fontWeight: 500
          },

          trim: true,
          hideOverlappingLabels: true
        },

        title: {
          text: undefined
        },

        tooltip: {
          enabled: false
        },

        crosshairs: {
          show: false
        }
      },

      yaxis: {
        min: 0,

        labels: {
          formatter: value => {
            const amount = Number(value);

            if (amount >= 1000000) {
              return `$${(amount / 1000000).toFixed(1)} M`;
            }

            if (amount >= 1000) {
              return `$${(amount / 1000).toFixed(1)} mil`;
            }

            return `$${amount.toLocaleString("es-MX")}`;
          },

          style: {
            colors: ["#8ca0af"],
            fontSize: "9px"
          }
        }
      },

      tooltip: {
        shared: true,
        intersect: false,
        theme: "light",

        custom: function ({
          series,
          dataPointIndex
        }) {

          const payment =
            paymentCards[dataPointIndex];

          const income =
            series?.[0]?.[dataPointIndex] ?? 0;

          const invoice =
            series?.[1]?.[dataPointIndex] ?? 0;

          return `
          <div class="finance-chart-tooltip">

            <div class="finance-chart-tooltip-title">
              ${payment?.title ?? ""}
            </div>

            <div class="finance-chart-tooltip-row">

              <span class="finance-chart-tooltip-dot income"></span>

              <span>
                Ingreso
              </span>

              <strong>
                $${Number(income).toLocaleString(
            "es-MX",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }
          )}
              </strong>

            </div>

            <div class="finance-chart-tooltip-row">

              <span class="finance-chart-tooltip-dot invoice"></span>

              <span>
                Facturado
              </span>

              <strong>
                $${Number(invoice).toLocaleString(
            "es-MX",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }
          )}
              </strong>

            </div>

          </div>
        `;
        }
      }
    }
  };






  return (
    <Fragment>
      {
        <ModalAutorizationInvoices
          {
          ...{ modalAutorization, toggleModalAutorization, saveInvoices, handleSelecUser, handleSelectPassword, validatePassword, loadingServices, username }
          }

        />
      }

      {
        // ? DIALOG PAYMENT
      }
      <Dialog
        maskClassName="custom-cancell-mask"
        header={
          <div className="Global-dialog-header">
            <div className="Global-dialog-header__content">

              <div className="Global-dialog-icon">
                <i className="fa fa-calendar "></i>
              </div>

              <div>
                <div className="Global-dialog-title">
                  Ingresos de otros meses
                </div>


              </div>

            </div>
          </div>
        }
        draggable={false}

        className={`Global-dialog Global-dialog Global-blue Global-small-2`}
        visible={modalviewPayment}
        modal
        dismissableMask
        onHide={togglePayment}

      >
        <Col sm="12" className='pb-3 pt-1 p-l-0 p-r-0'>
          <Col sm="7" className='pb-3 p-l-0' >
            <div
              style={{
                color: "#856404",
                fontSize: "0.78rem",
                marginTop: "6px",
                fontWeight: "500",
                backgroundColor: "#fff3cd",
                padding: "4px 10px",
                borderRadius: "6px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                border: "1px solid #ffeeba",
              }}
            >
              <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
              {"Registro de los pagos realizados de las facturas PPD efectuados en este periodo." ?? "---"}
            </div>
          </Col>
          <DataTable
            value={dataComplement}
            dataKey="idBranch"
            paginator
            rows={6}
            rowsPerPageOptions={[6, 20, 50, 100, 200]}
            responsiveLayout="scroll"
            emptyMessage={
              <div className="text-center">
                <img
                  src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                  style={{ width: "45%" }}
                  alt="Sin resultados"
                />
                <br />
                <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                  No hay ingresos de otros meses.
                </p>
              </div>
            }
          >
            <Column header="#" sortable body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="payment_date" sortable header="Fecha" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column header="Folio" body={(row) => tagInfo(row)} headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="nameBussines" sortable header="Receptor" headerStyle={headerStyle} style={centerStyle} footer="Totales:" footerStyle={footerStyle} />
            <Column field="payment_amount" sortable header="Monto" headerStyle={headerStyle} style={centerStyle} footer={`$${number_format(SumTotal, 2)}`} footerStyle={footerStyle} />
            <Column field="uuid" sortable header="UUID" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column header="Factura asociada" body={(row) => tagInfoInvoice(row)} headerStyle={headerStyle} style={centerStyle} footer="" />
          </DataTable>
        </Col>

      </Dialog>
      {
        // ? DIALOG DISCOUNT
      }
      <Dialog
        //  header={<label className='f-w-600'>Total de descuentos: <b className='txt-info' >{reportDiscounts.length ?? 0}</b>&nbsp;&nbsp;&nbsp;&nbsp; Monto de descuento: <b className='txt-danger' >&nbsp;&nbsp;${countDiscount}</b> </label>}
        visible={visible}
        onHide={hideModal}
        maskClassName="custom-cancell-mask"
        header={
          <div className="Global-dialog-header">
            <div className="Global-dialog-header__content">

              <div className="Global-dialog-icon">
                <i className="fa fa-percent"></i>
              </div>

              <div>
                <div className="Global-dialog-title">
                  Descuentos
                </div>
                <label style={{ fontSize: "13px" }}  >
                  Total de descuentos: <b className='txt-info'>{reportDiscounts.length}</b>&nbsp;&nbsp;&nbsp;&nbsp;
                  Monto de descuentos: <b className='txt-danger'>&nbsp;&nbsp;${countDiscount}</b>
                </label>


              </div>

            </div>
          </div>
        }
        draggable={false}

        className={`Global-dialog Global-dialog Global-blue Global-xl`}

      >
        <Col sm="12" className='p-l-0 p-r-0'>
          <Row>
            <Col sm="8" className='p-l-0 p-r-0'>
              <DataTable
                className="data-table"
                globalFilter={globalFilter}
                value={reportDiscounts}
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
                emptyMessage={
                  <div className="text-center">
                    <img
                      src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                      style={{ width: "25%" }}
                      alt="Sin resultados"
                    />
                    <br />
                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>No se a generada ningún descuento.</p>
                  </div>
                }
                header={
                  <Col sm="12" className='p-l-0 p-r-0'>
                    <Row>
                      <Col sm="7">
                      </Col>
                      <Col sm="1">
                        <Button icon="pi pi-file-excel"
                          data-pr-tooltip="Descargar Reporte"
                          style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}

                          className="p-button-success" onClick={() => exportToExcelDiscount(reportDiscounts)} />
                      </Col>
                      <Col sm="1">
                        <Button
                          icon="pi pi-chart-bar"
                          className="p-button-info"
                          onClick={downloadChart}
                          data-pr-tooltip="Descargar gráfica"
                          style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}
                        />
                        +
                      </Col>
                      <Col sm="2">
                        <span className="p-input-icon-left">
                          <InputText
                            type="search"
                            className="pl-6"
                            onInput={(e) => setGlobalFilter(e.target.value)}
                            style={{ width: "auto" }}
                          />
                          <i className="pi pi-search" />

                        </span>
                      </Col>
                    </Row>
                  </Col>
                }
              >
                <Column
                  header="#"
                  body={(rowData, { rowIndex }) => rowIndex + 1}
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    width: "5%",
                  }}
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                />

                <Column
                  field="nim"
                  header="Nim"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                  body={customBody}
                />
                <Column
                  field="name_branches"
                  header="Sucursal"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="name"
                  header="Paciente"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="age"
                  header="Edad"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="name_Preloaded_discount"
                  header="Descuento aplicado"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />


                <Column
                  field="amountDiscount"
                  header="Total de descuento"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                  body={(rowData) => `$${formatAmount(rowData.amountDiscount)}`}
                />

                <Column
                  field="percentagePreloaded_discount"
                  header="% Aplicado"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
              </DataTable>

            </Col>
            <Col sm="4" className="p-r-0">
              <Col sm="12">
                <div className="mt-3" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                  {chartData?.labels
                    ?.filter((_, index) => chartData.datasets[0]?.data[index] > 0)
                    .map((name, index) => ({
                      name,
                      total: chartData.datasets[0]?.data[index],
                      count: chartData.datasets[1]?.data[index],
                      index,

                    }))
                    .sort((a, b) => b.total - a.total)
                    .map((item, index) => (
                      <div
                        key={item.index}
                        style={{
                          padding: '0.7rem 1rem',
                          borderBottom: '1px solid #ddd',
                          fontSize: '14px',
                        }}
                      >
                        <strong>{index + 1}. {item.name}</strong><br />
                        <span>Total Descuento:</span> <span className="text-success">${item.total.toFixed(2)}</span><br />
                        <span>Veces Aplicado:</span> <span className="text-primary">{item.count}</span>
                      </div>
                    ))}
                </div>

              </Col>
            </Col>
          </Row>
        </Col>
        <Row>
          <Col sm="12" >
            <div

            >
              <Chart
                ref={chartRef}
                type="bar"
                data={chartData}
                options={chartOptions}
              />
            </div>
          </Col>
        </Row>


      </Dialog>
      {
        // ? DIALOG BONUS
      }
      <Dialog
        visible={visibleBonus}
        onHide={hideModalBonus}
        maskClassName="custom-cancell-mask"
        header={
          <div className="Global-dialog-header">
            <div className="Global-dialog-header__content">
              <div className="Global-dialog-icon">
                <i className="fa fa-gift"></i>
              </div>
              <div>
                <div className="Global-dialog-title">
                  Bonificaciones
                </div>
                <label style={{ fontSize: "13px" }}  >
                  Total de bonificaciones: <b className='txt-info'>{reportBonus.length}</b>&nbsp;&nbsp;&nbsp;&nbsp;
                  Monto de bonificaciones: <b className='txt-danger'>&nbsp;&nbsp;${countBonus}</b>
                </label>
              </div>
            </div>
          </div>
        }
        draggable={false}
        className={`Global-dialog Global-dialog Global-blue Global-xl`}
      >


        <Col sm="12" className='p-l-0 p-r-0 pt-2' >
          <Row>
            <Col sm="8" className='p-l-0 p-r-0' >
              <DataTable
                className="data-table"
                globalFilter={globalBonusFilter}
                value={reportBonus}
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
                emptyMessage={
                  <div className="text-center">
                    <img
                      src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                      style={{ width: "25%" }}
                      alt="Sin resultados"
                    />
                    <br />
                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>No se a generada ningún descuento.</p>
                  </div>
                }
                header={
                  <Col sm="12" className='p-l-0 p-r-0'>
                    <Row>
                      <Col sm="6">
                      </Col>
                      <Col sm="1">
                        <Button icon="pi pi-file-excel"
                          data-pr-tooltip="Descargar Reporte"
                          style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}

                          className="p-button-success" onClick={() => exportToExcelBonus(reportBonus)} />

                      </Col>
                      <Col sm="1">
                        <Button
                          icon="pi pi-chart-bar"
                          className="p-button-info"
                          onClick={handleDownload}
                          data-pr-tooltip="Descargar gráfica"
                          style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}
                        />
                      </Col>
                      <Col sm="2">
                        <span className="p-input-icon-left">
                          <InputText
                            type="search"
                            className="pl-6"
                            onInput={(e) => setGlobalBonusFilter(e.target.value)}
                            style={{ width: "auto" }}
                          />
                          <i className="pi pi-search" />

                        </span>
                      </Col>
                    </Row>
                  </Col>
                }
              >
                <Column
                  header="#"
                  body={(rowData, { rowIndex }) => rowIndex + 1}
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    width: "5%",
                  }}
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                />

                <Column
                  field="nim"
                  header="Nim"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                  body={customBody}

                />
                <Column
                  field="name_branches"
                  header="Sucursal"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="namePatient"
                  header="Paciente"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />


                <Column
                  field="nameMethod"
                  header="Metodo de pago"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="amount"
                  header="Monto"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                  body={(rowData) => `$${formatAmount(rowData.amount)}`}

                />
                <Column
                  field="fech"
                  header="Fecha"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="user_responsible"
                  header="Responsable"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
              </DataTable>
            </Col>
            <Col sm="4" className='p-r-0' >
              <Chart type="bar" data={chartDataBonus} ref={chartBonustRef} options={chartOptionsBonus} />
              <div className="mt-3">
                {chartDataBonus?.labels?.map((name, index) => (
                  <div
                    key={index}
                    style={{
                      padding: '0.7rem 1rem',
                      borderBottom: '1px solid #ddd',
                      fontSize: '14px',
                    }}
                  >
                    <strong>{index + 1}. {name}</strong><br />
                    <span>Total Bonificado:</span> <span className="text-success">${chartDataBonus.datasets[0].data[index].toFixed(2)}</span><br />
                    <span>Veces Aplicado:</span> <span className="text-primary">{chartDataBonus.datasets[1].data[index]}</span>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Col>





      </Dialog>
      {
        // ? DIALOG CANCELL
      }
      <Dialog
        maskClassName="custom-cancell-mask"
        header={
          <div className="Global-dialog-header">
            <div className="Global-dialog-header__content">

              <div className="Global-dialog-icon">
                <i className="fa fa-times-circle"></i>
              </div>

              <div>
                <div className="Global-dialog-title">
                  Cancelaciones
                </div>
                <label style={{ fontSize: "13px" }}  >
                  Total de cancelaciones: <b className='txt-info'>{cancellPatient.length}</b>&nbsp;&nbsp;&nbsp;&nbsp;
                  Monto de cancelaciones: <b className='txt-danger'>&nbsp;&nbsp;${countPatient}</b>
                </label>


              </div>

            </div>
          </div>
        }
        draggable={false}

        className={`Global-dialog Global-dialog Global-blue Global-xl`}

        visible={visibleCancell}
        onHide={hideModalCancel}

      >
        <div>
          <Col sm="12" className='p-l-0 p-r-0' >
            <TabView className='pl-0 pr-0' >
              <TabPanel header="Reporte" className='pl-0 pr-0' >
                <DataTable
                  className="data-table"
                  globalFilter={globalCancellFilter}
                  value={cancellPatient}
                  paginator
                  rows={5}
                  rowsPerPageOptions={[5, 20, 50, 100]}
                  emptyMessage={
                    <div className="text-center">
                      <img
                        src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                        style={{ width: "25%" }}
                        alt="Sin resultados"
                      />
                      <br />
                      <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>No se a generada ningún descuento.</p>
                    </div>
                  }
                  header={
                    <Col sm="12" className='p-l-0 p-r-0'>
                      <Row>
                        <Col sm="6">
                        </Col>
                        <Col sm="1">
                          <Button icon="pi pi-file-excel"
                            data-pr-tooltip="Descargar Reporte"
                            style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}

                            className="p-button-success" onClick={() => exportToExcelCancell(cancellPatient)} />

                        </Col>
                        <Col sm="1">
                          <Button
                            icon="pi pi-chart-bar"
                            className="p-button-info"
                            onClick={handleCancellDownload}
                            data-pr-tooltip="Descargar gráfica"
                            style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}
                          />
                        </Col>
                        <Col sm="2">
                          <span className="p-input-icon-left">
                            <InputText
                              type="search"
                              className="pl-6"
                              onInput={(e) => setGlobalCancellFilter(e.target.value)}
                              style={{ width: "auto" }}
                            />
                            <i className="pi pi-search" />

                          </span>
                        </Col>
                      </Row>
                    </Col>
                  }
                >
                  <Column
                    header="#"
                    body={(rowData, { rowIndex }) => rowIndex + 1}
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      width: "5%",
                    }}
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                  />

                  <Column
                    field="nim"
                    header="Nim"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                    body={customBody}
                  />
                  <Column
                    field="branch"
                    header="Sucursal"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                  />
                  <Column
                    field="name_patient"
                    header="Paciente"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                  />

                  <Column
                    field="type"
                    header="Tipo de ingreso"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                  />
                  <Column
                    field="amount"
                    header="Monto"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                    body={(rowData) => `$${formatAmount(rowData.amount)}`}

                  />
                  <Column
                    field="reazon_cancellation"
                    header="Motivo de cancelación"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                  />


                  <Column
                    field="user_autorized"
                    header="Responsable"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                  />
                  <Column
                    field="date_cancellation"
                    header="Fecha de cancalación"
                    sortable
                    headerStyle={{
                      backgroundColor: "#1d5b83",
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: "10px",
                      padding: "5px",
                    }}
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "10%",
                    }}
                  />

                </DataTable>
              </TabPanel>
              <TabPanel header="Graficas" className='pl-0 pr-0'>
                <Row style={{ scrollBehavior: "smooth", transform: "scale(0.7)", width: "135%", transformOrigin: "top left" }} >
                  <Col sm="6">
                    <div className="card">
                      <h5 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "20px" }}>
                        Cancelaciones por Responsable
                      </h5>
                      <Chart
                        type="bar"
                        data={chartDataCancell}
                        options={chartOptionsCancell}
                        ref={chartCancellRef}
                      />
                      <div className="table-responsive mt-4">
                        <table className="table table-striped table-bordered" style={{ fontSize: "13px" }}>
                          <thead style={{ backgroundColor: "#1d5b83", color: "#fff" }}>
                            <tr>
                              <th style={{ textAlign: "left", color: "#fff" }}>Responsable</th>
                              <th style={{ textAlign: "center", color: "#fff" }}>Veces Aplicadas</th>
                              <th style={{ textAlign: "right", color: "#fff" }}>Total Cancelado ($)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {chartDataCancell?.labels?.map((name, index) => (
                              <tr key={index}>
                                <td>{name}</td>
                                <td style={{ textAlign: "center" }}>
                                  {chartDataCancell.datasets[1].data[index]}
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  ${chartDataCancell.datasets[0].data[index].toFixed(2)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                  <Col sm="6">
                    <div className="card">
                      <h5 style={{ textAlign: "center", fontWeight: "bold", marginBottom: "20px" }}>
                        Total Cancelado por Motivo
                      </h5>
                      <Chart type="bar" data={chartDataReason} options={chartOptionsReason} />
                      <div className="table-responsive mt-4">
                        <table className="table table-striped table-bordered" style={{ fontSize: "13px" }}>
                          <thead style={{ backgroundColor: "#1d5b83", color: "#fff" }}>
                            <tr>
                              <th style={{ textAlign: "left", color: "#fff" }}>Motivo de cancelación</th>
                              <th style={{ textAlign: "center", color: "#fff" }}>Cantidad de veces</th>
                              <th style={{ textAlign: "right", color: "#fff" }}>Total cancelado ($)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(groupedByReason).map(([reason, { totalAmount, count }]) => (
                              <tr key={reason}>
                                <td>{reason}</td>
                                <td style={{ textAlign: "center" }}>{count}</td>
                                <td style={{ textAlign: "right" }}>${totalAmount.toFixed(2)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </TabPanel>
            </TabView>
          </Col>
        </div>
      </Dialog>
      {
        // ? DIALOG DEVOLUTION
      }
      <Dialog
        // header={<label className='f-w-600'>Total de devoluciones: <b className='txt-info' >{devolutionPatient.length}</b>&nbsp;&nbsp;&nbsp;&nbsp; Monto de devoluciones: <b className='txt-danger' >&nbsp;&nbsp;${countDevolution}</b> </label>}
        visible={visibleDevolution}
        onHide={hideModalDevolution}
        modal
        maskClassName="custom-cancell-mask"
        header={
          <div className="Global-dialog-header">
            <div className="Global-dialog-header__content">

              <div className="Global-dialog-icon">
                <i className="fa fa-reply"></i>
              </div>

              <div>
                <div className="Global-dialog-title">
                  Devoluciones
                </div>
                <label style={{ fontSize: "13px" }}  >
                  Total de devoluciones: <b className='txt-info'>{devolutionPatient.length}</b>&nbsp;&nbsp;&nbsp;&nbsp;
                  Monto de devoluciones: <b className='txt-danger'>&nbsp;&nbsp;${countDevolution}</b>
                </label>


              </div>

            </div>
          </div>
        }
        draggable={false}

        className={`Global-dialog Global-dialog Global-blue Global-xl`}

      >
        <Col sm="12" className='p-l-0 p-r-0' >
          <Col sm="6" className='pb-3 p-l-0' >
            <div
              style={{
                color: "#856404",
                fontSize: "0.78rem",
                marginTop: "6px",
                fontWeight: "500",
                backgroundColor: "#fff3cd",
                padding: "4px 10px",
                borderRadius: "6px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                border: "1px solid #ffeeba",
              }}
            >
              <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
              {"Reporte de pacientes que se efectuo una devolución en sus estudios" ?? "---"}
            </div>
          </Col>
          <Row>
            <Col sm="12" md="8" lg="8" className='p-l-0 p-r-0' >
              <DataTable
                className="data-table"
                globalFilter={globalDevolutionFilter}
                value={devolutionPatient}
                paginator
                rows={5}
                rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
                emptyMessage={
                  <div className="text-center">
                    <img
                      src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                      style={{ width: "25%" }}
                      alt="Sin resultados"
                    />
                    <br />
                    <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>No se a generada ningún descuento.</p>
                  </div>
                }
                header={
                  <Col sm="12" className='p-l-0 p-r-0'>
                    <Row>
                      <Col sm="6">
                      </Col>
                      <Col sm="1">
                        <Button icon="pi pi-file-excel"
                          data-pr-tooltip="Descargar Reporte"
                          style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}
                          className="p-button-success" onClick={() => exportToExcelDevolution(devolutionPatient)} />

                      </Col>
                      <Col sm="1">
                        <Button
                          icon="pi pi-chart-bar"
                          className="p-button-info"
                          onClick={handleDevolutionDownload}
                          data-pr-tooltip="Descargar gráfica"
                          style={{ fontSize: '12px', padding: '4px 8px', height: '30px' }}
                        />
                      </Col>
                      <Col sm="2">
                        <span className="p-input-icon-left">
                          <InputText
                            type="search"
                            className="pl-6"
                            onInput={(e) => setGlobalDevolutionFilter(e.target.value)}
                            style={{ width: "auto" }}
                          />
                          <i className="pi pi-search" />

                        </span>
                      </Col>
                    </Row>
                  </Col>
                }
              >
                <Column
                  header="#"
                  body={(rowData, { rowIndex }) => rowIndex + 1}
                  style={{
                    textAlign: "center",
                    fontSize: "12px",
                    width: "5%",
                  }}
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                />

                <Column
                  field="nim"
                  header="Nim"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                  body={customBody}
                />
                <Column
                  field="branch"
                  header="Sucursal"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="name_patient"
                  header="Paciente"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="amount"
                  header="Monto"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                  body={(rowData) => `$${formatAmount(rowData.amount)}`}

                />
                <Column
                  field="reazon_cancellation"
                  header="Motivo de devolución"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />


                <Column
                  field="user_autorized"
                  header="Responsable"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />
                <Column
                  field="date_cancellation"
                  header="Fecha de devolución"
                  sortable
                  headerStyle={{
                    backgroundColor: "#1d5b83",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "10px",
                    padding: "5px",
                  }}
                  style={{
                    fontSize: "10px",
                    textAlign: "center",
                    width: "10%",
                  }}
                />

              </DataTable>
            </Col>
            <Col sm="12" md="4" lg="4" className='p-r-0' >
              <Chart type="bar" data={chartDataDevolution} ref={chartDevolutionRef} options={chartOptionsDevolution} />
              <div className="mt-3">
                {chartDataDevolution?.labels?.map((name, index) => (
                  <div
                    key={index}
                    style={{
                      padding: '0.7rem 1rem',
                      borderBottom: '1px solid #ddd',
                      fontSize: '14px',
                    }}
                  >
                    <strong>{index + 1}. {name}</strong><br />
                    <span>Total Devuelto:</span> <span className="text-success">${chartDataDevolution.datasets[0].data[index].toFixed(2)}</span><br />
                    <span>Veces Aplicado:</span> <span className="text-primary">{chartDataDevolution.datasets[1].data[index]}</span>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Col>
      </Dialog>
      {
        // ? BANKING
      }
      <Dialog
        header={<label className='f-w-600'>Deposito bancario</label>}
        visible={visibleBanking}
        onHide={hideModalBanking}
        modal
        headerStyle={{
          backgroundColor: '#0d3b59',
          color: 'white',
          fontWeight: 'bold',
        }}
        pt={{
          header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
          headerIcon: { style: { color: 'white' } },
          content: { style: { paddingLeft: "1px" } }
        }}
      >

        <Col sm="12" className='pb-3 pt-4 p-l-0 p-r-0'>
          <Col sm="6" className='pb-3 p-l-0 ' >
            <div
              style={{
                color: "#856404",
                fontSize: "0.78rem",
                marginTop: "6px",
                fontWeight: "500",
                backgroundColor: "#fff3cd",
                padding: "4px 10px",
                borderRadius: "6px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                border: "1px solid #ffeeba",
              }}
            >
              <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
              {"Registros generados de los depositos realizados." ?? "---"}
            </div>
          </Col>

          <DataTable
            value={arrayDeposits}
            dataKey="idBranch"
            paginator
            rows={10}
            rowsPerPageOptions={[10, 50, 100, 200]}
            responsiveLayout="scroll"
            emptyMessage={
              <div className="text-center">
                <img
                  src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                  style={{ width: "45%" }}
                  alt="Sin resultados"
                />
                <br />
                <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                  No hay cortesias aplicadas.
                </p>
              </div>
            }
          >
            <Column header="#" sortable body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="date_1" sortable header="Fecha" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="user_delivere" sortable header="Usuario que entrego" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="user_received" sortable header="Usuario que recibio" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="observation" sortable header="Observación" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="amount" sortable header="Monto" body={(rowData) => `$${number_format(rowData?.amount ?? 0, 2)}`}
              headerStyle={headerStyle} style={centerStyle} footer={`$${number_format(arrayDeposits.reduce((acc, curr) => acc + (curr?.amount ?? 0), 0), 2)}`} footerStyle={footerStyle} />
          </DataTable>
        </Col>
      </Dialog>
      {
        // ? MEMBRESIA
      }
      <Dialog
        header={<label className='f-w-600'>Membresia</label>}
        visible={visibleMembresia}
        onHide={hideModalMembresia}
        modal
        headerStyle={{
          backgroundColor: '#0d3b59',
          color: 'white',
          fontWeight: 'bold',
        }}
        pt={{
          header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
          headerIcon: { style: { color: 'white' } },
          content: { style: { paddingLeft: "1px" } }
        }}
      >
        <Col sm="12" className='pb-3 pt-4 p-l-0 p-r-0'>
          <Col sm="6" className='pb-3 p-l-0' >
            <div
              style={{
                color: "#856404",
                fontSize: "0.78rem",
                marginTop: "6px",
                fontWeight: "500",
                backgroundColor: "#fff3cd",
                padding: "4px 10px",
                borderRadius: "6px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                border: "1px solid #ffeeba",
              }}
            >
              <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
              {"Registros que no suman a los totales globales en indicadores." ?? "---"}
            </div>
          </Col>

          <DataTable
            value={dataCortesy}
            dataKey="idBranch"
            paginator
            rows={10}
            rowsPerPageOptions={[10, 50, 100, 200]}
            responsiveLayout="scroll"
            emptyMessage={
              <div className="text-center">
                <img
                  src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                  style={{ width: "45%" }}
                  alt="Sin resultados"
                />
                <br />
                <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                  No hay cortesias aplicadas.
                </p>
              </div>
            }
          >
            <Column header="#" sortable body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="date" sortable header="Fecha" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="nim" sortable header="Nim" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="namePatient" sortable header="Paciente" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="amount" sortable header="Monto" body={(rowData) => `$${number_format(rowData?.amount ?? 0, 2)}`} headerStyle={headerStyle} style={centerStyle} footer={`$${number_format(dataCortesy.reduce((acc, curr) => acc + (curr?.amount ?? 0), 0), 2)}`} footerStyle={footerStyle} />
          </DataTable>
        </Col>
      </Dialog>
      { // ? MAIN DIALOG
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }} >
          <Col sm="12" style={{ marginTop: "2px" }}>
            {
              (activeView === 2 && !valid_view) && <TabMenu
                model={items}
                activeIndex={activeIndex}
                onTabChange={(e) => {
                  console.log("🚀 ~ IndexBankingDeposits ~ e:", e);

                  setActiveIndex(e.index);
                  setActiveView(e.index === 2 ? 0 : 2);
                }}
                className="banking-tabmenu-style"
                style={{ marginBottom: "1px" }}
              />
            }


            <Card>

              {activeIndex === 0 && (
                <Col sm="12" className={valid_view ? "pl-0 pr-0" : ''}    >

                  {
                    !valid_view &&
                    <Row className={type_action === "A" ? 'dashboard-sec box-col-12' : (["F", "R", "C", "D"].includes(type_action) ? 'd-none' : 'dashboard-sec box-col-12')} >
                      <Col sm="12" style={{ textAlign: "center" }}>
                        {
                          loading && <i className="fa fa-spin fa-spinner font-primary f-46"></i>
                        }
                      </Col>


                      {
                        // * DASHBOARD
                      }

                      <Col sm="12" className="finance-dashboard">
                        <div className="finance-panel finance-payment-panel">
                          <div className="finance-payment-grid">
                            {
                              paymentCards.map(item => {

                                const amount = Number(item.amount ?? 0);
                                const invoiceAmount = Number(item.invoiceAmount ?? 0);

                                return (
                                  <div
                                    key={item.id}
                                    className={item.onClick ? "finance-payment-card pointer" : "finance-payment-card"}
                                    onClick={item.onClick ? item.onClick : undefined}
                                  >

                                    <div className="finance-payment-top">
                                      <div className="finance-payment-icon">
                                        <i className={item.icon}></i>
                                      </div>

                                      <div className="finance-payment-information">

                                        <span className="finance-payment-title">
                                          {item.title}
                                        </span>

                                        <strong className="finance-payment-amount">
                                          ${number_format(amount, 2)}
                                        </strong>

                                      </div>

                                    </div>


                                    <div className="finance-payment-footer">
                                      <div className="finance-payment-invoice-row">
                                        <span>
                                          Facturado
                                        </span>

                                        <strong>
                                          ${number_format(invoiceAmount, 2)}
                                        </strong>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}

                            {
                              // * DEPOSITS
                            }

                            {
                              arrayDeposits?.length > 0 && (
                                <div
                                  className="finance-payment-card pointer"
                                  onClick={showModalBanking}
                                >

                                  <div className="finance-payment-top">
                                    <div className="finance-payment-icon">
                                      <i className="fa fa-university"></i>
                                    </div>

                                    <div className="finance-payment-information">
                                      <span className="finance-payment-title">
                                        Depósito bancario
                                      </span>

                                      <strong className="finance-payment-amount">
                                        ${number_format(totalBankDeposits, 2)}
                                      </strong>

                                    </div>
                                  </div>
                                </div>
                              )}


                            {
                              dataCortesy?.length > 0 && (
                                <div className="finance-payment-card pointer" onClick={showModalMembresia} >
                                  <div className="finance-payment-top">
                                    <div className="finance-payment-icon finance-payment-icon-membership">
                                      <i className="fa fa-id-card-o"></i>
                                    </div>

                                    <div className="finance-payment-information">
                                      <span className="finance-payment-title">
                                        Membresía
                                      </span>

                                      <strong className="finance-payment-amount">
                                        ${number_format(totalMembership, 2)}
                                      </strong>

                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>



                        {!isComplement && (

                          <div className="finance-main-grid">
                            <div className="finance-panel finance-filter-panel">
                              <div className="finance-panel-header">
                                <div>
                                  <h5>
                                    <i className="fa fa-filter"></i>Filtros
                                  </h5>
                                </div>
                              </div>


                              <div className="finance-filter-body">
                                <FormGroup>
                                  <label> Fecha inicio  </label>
                                  <Input
                                    type="date"
                                    name="start_date"
                                    value={start_date}
                                    onChange={(e) => handleInputChange(e)}
                                    className="finance-date-input"
                                  />
                                </FormGroup>

                                <FormGroup>
                                  <label>  Fecha fin  </label>
                                  <Input
                                    type="date"
                                    name="end_date"
                                    value={end_date}
                                    onChange={(e) => handleInputChange(e)}
                                    className="finance-date-input"
                                  />
                                </FormGroup>

                                <button
                                  type="button"
                                  className="finance-search-button"
                                  onClick={() => handleActions()}
                                  disabled={loadingDeposits}
                                >

                                  {loadingDeposits ? (
                                    <>
                                      <span className="spinner-border spinner-border-sm" role="status" />

                                      <span>
                                        Buscando...
                                      </span>
                                    </>

                                  ) : (
                                    <>
                                      <i className="fa fa-search"></i>
                                      <span style={{ fontSize: "12px" }} >
                                        Buscar
                                      </span>
                                    </>
                                  )}
                                </button>
                              </div>
                            </div>


                            <div className="finance-panel finance-chart-panel">
                              <div className="finance-chart-body">
                                {loadingDeposits ? (
                                  <div className="finance-loading finance-loading-compact">
                                    <div className="finance-loading-card">
                                      <div className="finance-loading-logo-wrap">

                                        <div className="finance-loading-ring finance-loading-ring-1"></div>
                                        <div className="finance-loading-ring finance-loading-ring-2"></div>

                                        <div className="finance-loading-logo">
                                          <img
                                            alt="Cargando"
                                            src={require(
                                              "../../assets/images/loginHelenLabs/HelenLabs.png"
                                            )}
                                          />
                                        </div>

                                      </div>

                                      <h3 className="finance-loading-title">
                                        Cargando información
                                      </h3>

                                      <span className="finance-loading-text">
                                        Procesando información...
                                      </span>

                                      <div className="finance-loading-progress">
                                        <div className="finance-loading-progress-bar"></div>
                                      </div>

                                    </div>
                                  </div>

                                ) : (
                                  <ApexCharts
                                    options={paymentAreaChart.options}
                                    series={paymentAreaChart.series}
                                    type="area"
                                    height={220}
                                  />
                                )}
                              </div>
                            </div>



                            <div className="finance-indicators-side">
                              <div className="finance-kpi-card finance-kpi-primary">

                                <div className="finance-kpi-icon">
                                  <i className="icofont icofont-cur-dollar"></i>
                                </div>

                                <div className="finance-kpi-content">
                                  <span className="finance-kpi-label">
                                    Total facturado
                                  </span>

                                  <strong className="finance-kpi-value">
                                    ${number_format(indicatorAmountInvoice, 2)}
                                  </strong>
                                </div>

                                <div className="finance-kpi-decoration">
                                  <i className="fa fa-line-chart"></i>
                                </div>

                              </div>


                              <div className="finance-kpi-card finance-kpi-info pointer" onClick={handlePayment}   >

                                <div className={isComplement ? "finance-kpi-icon finance-kpi-icon-dark" : "finance-kpi-icon"}  >

                                  <i
                                    className={
                                      isComplement
                                        ? "fa fa-times"
                                        : "fa fa-calendar"
                                    }
                                  ></i>

                                </div>

                                <div className="finance-kpi-content">

                                  <span className="finance-kpi-label">
                                    Ingreso de otros meses
                                  </span>

                                  <strong className="finance-kpi-value">
                                    ${number_format(
                                      totalComplement,
                                      2
                                    )}
                                  </strong>



                                </div>

                                <div className="finance-kpi-decoration">
                                  <i className="fa fa-calendar-o"></i>
                                </div>

                              </div>


                              {/* INGRESO CANCELADO */}

                              <div
                                className="finance-kpi-card finance-kpi-danger pointer"
                                onClick={showModalCancel}
                              >

                                <div className="finance-kpi-icon finance-kpi-icon-danger">
                                  <i className="fa fa-times"></i>
                                </div>

                                <div className="finance-kpi-content">

                                  <span className="finance-kpi-label">
                                    Ingreso cancelado
                                  </span>

                                  <strong className="finance-kpi-value">
                                    ${number_format(
                                      countPatient,
                                      2
                                    )}
                                  </strong>



                                </div>

                                <div className="finance-kpi-decoration finance-kpi-decoration-danger">
                                  <i className="fa fa-ban"></i>
                                </div>

                              </div>


                              {/* TOTAL PACIENTES */}

                              {_valid_Finance !== "True" && (

                                <div className="finance-kpi-card finance-kpi-success">

                                  <div className="finance-kpi-icon finance-kpi-icon-success">
                                    <i className="fa fa-users"></i>
                                  </div>

                                  <div className="finance-kpi-content">

                                    <span className="finance-kpi-label">
                                      Total de pacientes
                                    </span>

                                    <strong className="finance-kpi-value">
                                      {indicatorPatient}
                                    </strong>

                                    <small className="finance-kpi-description">
                                      Pacientes registrados
                                    </small>

                                  </div>

                                  <div className="finance-kpi-decoration finance-kpi-decoration-success">
                                    <i className="fa fa-user-o"></i>
                                  </div>

                                </div>

                              )}

                            </div>


                          </div>

                        )}



                        {/* =========================================================
        INDICADORES INFERIORES
    ========================================================= */}


                      </Col>






                      {
                        //*  END COL
                      }




                      <Col sm="12" className='p-l-0 p-r-0' >
                        <Toolbar
                          className="finance-summary-toolbar"
                          left={leftContents}
                        />
                      </Col>
                    </Row >
                  }


                  {
                    !valid_view &&
                    // <div style={{ paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "111%", transformOrigin: "top left", textAlign: "center", height: "20%" }}>

                    <Col sm="12" className={_validationFinance ? 'd-none' : 'pt-1 pt-2 p-l-0 p-r-0'}  >
                      <DataTable
                        value={formattedData}
                        rowGroupMode="subheader"
                        groupRowsBy="branchName"
                        sortMode="single"
                        sortField="branchName"
                        sortOrder={1}
                        className="data-table"
                        scrollable
                        scrollHeight="600px"
                        rowGroupHeaderTemplate={headerTemplate}
                        tableStyle={{ minWidth: '80rem' }}
                      >
                        <Column field="branchName" header="Sucursal" body={() => null} style={{ display: 'none' }} />
                        <Column
                          field="payments"
                          header="Métodos de Pago"
                          body={paymentBodyTemplate}
                          headerStyle={{
                            backgroundColor: "#1d5b83",
                            color: "#fff",
                            fontWeight: "bold",
                            fontSize: "10px",
                            padding: "10px",
                          }}
                          style={{
                            fontSize: "12px",
                            width: "30%",
                          }}
                        />
                      </DataTable>
                    </Col>
                  }
                  {
                    valid_view && <IndexPatientCredit
                      companyInfo={companyInfo}
                      formatter={formatter}
                      navigateNim={navigateNim}
                      valid_view={valid_view}
                      cancellPatient={cancellPatient}
                      countPatient={countPatient}
                      exportToExcelCancell={exportToExcelCancell}
                      handleClosedView={handleClosedView}

                    />

                  }
                </Col >
              )}
              {
                activeIndex === 1 && (
                  <Col sm="12" className="bank-deposit-page">


                    <div className="bank-deposit-header">

                      <div className="bank-deposit-header-info">
                        <div className="bank-deposit-header-icon">
                          <i className="fa fa-university" />
                        </div>

                        <div>
                          <h5>Depósito bancario</h5>
                          <span>
                            Consulta depósitos registrados o genera uno nuevo
                          </span>
                        </div>
                      </div>

                      <div className="bank-deposit-header-actions">

                        <button
                          type="button"
                          className="bank-btn bank-btn-secondary"
                          onClick={() => GetDeposits()}
                        >
                          {/* <i className="fa fa-search" /> */}
                          Buscar depósitos
                        </button>

                        <button
                          type="button"
                          className="bank-btn bank-btn-primary"
                          onClick={() => saveReceived()}
                          disabled={disabledSaveButton === true}
                        >
                          {/* <i className="fa fa-floppy-o" /> */}
                          Guardar depósito
                        </button>

                      </div>

                    </div>



                    <div className="bank-deposit-content">


                      <div className="bank-calendar-section">

                        <div className="bank-section-heading">

                          <div className="bank-section-icon">
                            <i className="fa fa-calendar-o" />
                          </div>

                          <div>
                            <h6>Calendario</h6>
                            <span>Selecciona una fecha</span>
                          </div>

                        </div>

                        <Calendar
                          onChange={onChange}
                          value={date}
                          tileClassName={tileClassName}
                          className="bank-calendar"
                          locale="es-ES"
                        />

                      </div>



                      <div
                        className={`bank-form-section ${disabledSaveButton === true
                          ? "bank-section-disabled"
                          : ""
                          }`}
                      >

                        <div className="bank-warning">

                          <div className="bank-warning-icon">
                            <i className="fa fa-exclamation-triangle" />
                          </div>

                          <div>
                            <strong>Importante</strong>

                            <span>
                              Estos depósitos serán visibles en el dashboard
                              y no podrán ser editados nuevamente.
                            </span>
                          </div>

                        </div>



                        <div className="bank-date-container">

                          {
                            validNotification === true &&
                            range === true && (
                              <div className="bank-field bank-date-field">

                                <label>
                                  Fecha inicial
                                </label>

                                <div className="bank-input-wrapper">

                                  <i className="fa fa-calendar" />

                                  <input
                                    type="date"
                                    className="bank-input"
                                    name="date_2"
                                    value={date_2}
                                    onChange={(e) => handleInputChange(e)}
                                  />

                                </div>

                              </div>
                            )
                          }


                          {
                            one !== true && (
                              <div className="bank-field bank-date-field">

                                <label>
                                  {
                                    validNotification === true &&
                                      range === true
                                      ? "Fecha final"
                                      : "Fecha del depósito"
                                  }
                                </label>

                                <div className="bank-input-wrapper">

                                  <i className="fa fa-calendar" />

                                  <input
                                    type="date"
                                    className={`bank-input ${validationsSG.received
                                      ? "bank-input-valid"
                                      : ""
                                      }`}
                                    name="date_1"
                                    value={date_1}
                                    onChange={(e) => handleInputChange(e)}
                                  />

                                </div>

                              </div>
                            )
                          }

                        </div>



                        <div className="bank-form-grid">

                          <div className="bank-field">

                            <label>
                              Quién recibió
                              <span className="bank-required">*</span>
                            </label>

                            <div className="bank-input-wrapper">

                              <i className="fa fa-user-o" />

                              <input
                                type="text"
                                className="bank-input"
                                name="received"
                                value={received}
                                onChange={(e) => handleInputChange(e)}
                                placeholder="Nombre de quien recibió"
                              />

                            </div>

                          </div>


                          <div className="bank-field">

                            <label>
                              Quién entregó
                              <span className="bank-required">*</span>
                            </label>

                            <div className="bank-input-wrapper">

                              <i className="fa fa-user" />

                              <input
                                type="text"
                                className="bank-input"
                                name="delivere"
                                value={delivere}
                                onChange={(e) => handleInputChange(e)}
                                placeholder="Nombre de quien entregó"
                              />

                            </div>

                          </div>


                          <div className="bank-field">

                            <label>
                              Total a depositar
                              <span className="bank-required">*</span>
                            </label>

                            <div className="bank-input-wrapper bank-amount-input">

                              <span className="bank-currency">$</span>

                              <input
                                type="text"
                                className="bank-input"
                                name="amount"
                                value={amount}
                                onChange={(e) => handleInputChange(e)}
                                placeholder="0.00"
                              />

                            </div>

                          </div>

                        </div>



                        <div className="bank-field bank-observation-field">

                          <label>
                            Observaciones
                            <span className="bank-optional">
                              Opcional
                            </span>
                          </label>

                          <div className="bank-textarea-wrapper">

                            <textarea
                              className="bank-textarea"
                              name="observation"
                              rows="4"
                              value={observation}
                              onChange={handleInputChange}
                              placeholder="Escribe alguna observación relacionada con el depósito..."
                            />

                          </div>

                        </div>



                        {
                          validNotification === true && (
                            <div className="bank-user-decoration">

                              <Media
                                body
                                src={require(
                                  "../../assets/images/loginHelenLabs/User/UserWoman.svg"
                                )}
                                alt=""
                              />

                            </div>
                          )
                        }

                      </div>

                    </div>

                  </Col>
                )
              }
              {
                activeIndex === 2 && (
                  <Col sm="12" className='pos-container pl-0 pr-0' >
                    <Card style={{
                      marginBottom: '15px',
                      background: 'linear-gradient(135deg, #235e81 0%, #09385b 100%)',
                      border: 'none',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                    }} className='container-global-zoom'>
                      <CardBody style={{ padding: '18px 25px' }}>
                        <div className="d-flex align-items-center justify-content-between">

                          <div className="d-flex align-items-center">
                            <div
                              style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginRight: '15px'
                              }}
                            >
                              <img
                                alt="flask"
                                className="img-fluid"
                                src={require("../../assets/images/quoter/quoter-clinics.svg")}
                                style={{ width: "60px", height: "60px" }}
                              />
                            </div>

                            <div>
                              <h4
                                className="mb-1"
                                style={{
                                  color: '#fff',
                                  fontWeight: 700,
                                  fontSize: '20px'
                                }}
                              >
                                Pacientes pendientes a facturar
                              </h4>

                              <small
                                style={{
                                  color: 'rgba(255,255,255,0.85)',
                                  fontSize: '14px'
                                }}
                              >
                                <i className="fa fa-info-circle mr-1"></i>
                                Visualización y gestión de pacientes particulares que aún están
                                pendientes a facturar o que requieren su factura.
                              </small>
                            </div>
                          </div>

                          {/* Indicador */}
                          <div
                            style={{
                              background: "rgba(255,255,255,.15)",
                              border: "1px solid rgba(255,255,255,.25)",
                              borderRadius: "14px",
                              // padding: "10px 18px",
                              minWidth: "150px",
                              textAlign: "center",
                              color: "#fff"
                            }}
                          >

                            {
                              activeView === 0 && <div style={{ fontSize: "28px", fontWeight: 700 }}>
                                {loadingPending ? (
                                  <i className="fa fa-spinner fa-spin"></i>
                                ) : (
                                  filteredInvoicess.length
                                )}
                              </div>
                            }

                            {
                              activeView === 1 && <div style={{ fontSize: "28px", fontWeight: 700 }}>
                                {loadingInvoice ? (
                                  <i className="fa fa-spinner fa-spin"></i>
                                ) : (
                                  filteredInvoices.length
                                )}
                              </div>
                            }



                            <div style={{ fontSize: "13px", opacity: .9 }}>
                              <i className="fa fa-file-text-o mr-1"></i>
                              Facturas pendientes
                            </div>
                          </div>

                        </div>
                      </CardBody>
                    </Card>
                    <header className="pos-header">
                      <Row className="quoter-header-row d-none d-md-flex" style={{
                        position: "relative",
                        zIndex: 1
                      }}>

                        <Col
                          xs="12"
                          lg={activeView === 0 ? "12" : "12"}
                          className="quoter-header-block header-buttons"
                        >
                          <div
                            className=

                            "full-tabs-quoter-clinics"


                          >
                            <Button
                              size="sm"
                              onClick={() => requestChangeType(0)}
                              className={`pos-pill-tab-quoter-clinics ${activeView === 0 ? "active" : ""
                                }`}
                            >
                              <i className="icofont icofont-search"></i>
                              Pacientes pendientes de facturar

                            </Button>

                            <Button
                              size="sm"
                              onClick={() => requestChangeType(1)}
                              className={`pos-pill-tab-quoter-clinics ${activeView === 1 ? "active" : ""
                                }`}
                            >
                              <i className="icofont icofont-user-alt-5"></i>
                              Pacientes que requieren factura

                            </Button>


                          </div>
                        </Col>


                        <Col
                          xs="12"
                          lg="auto"
                          className="d-flex justify-content-end pl-0 header-block header-menu mobile-only"
                        >
                          <div className="quoter-icon-toggle">
                            <i className="fa fa-bars"></i>
                          </div>
                        </Col>
                      </Row>

                    </header>

                    <div className="pos-body">
                      <div className="pos-main">
                        {/* { */}
                        <div className='container-global-zoom'>

                          <Col sm="12" className='pt-2 pl-0 pr-0' >
                            <Row>
                              <Col sm="2" style={{ textAlign: "left" }}>
                                <Card style={{
                                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                  border: 'none',
                                  height: '100%',
                                  borderRadius: '12px'
                                }}>
                                  <CardHeader style={{
                                    background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                                    color: 'white',
                                    padding: '15px',
                                    borderRadius: '12px 12px 0 0'
                                  }}>
                                    <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                      <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                                    </h6>
                                  </CardHeader>
                                  <CardBody className='pt-1' style={{ padding: '20px' }}>
                                    <FormGroup>
                                      <label className='f-w-600 label-report'>
                                        <i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Sucursal
                                      </label>
                                      <Input
                                        style={{
                                          borderColor: "#5bbfff",
                                          borderStyle: "solid",
                                          borderWidth: "1px",
                                          borderRadius: "15px",
                                          height: "35px",
                                          fontSize: "13px",
                                        }}
                                        type="select"
                                        onChange={(e) => handleSelectBranch(e.target.value)}
                                      >
                                        <option value={0}>Selecciona una sucursal</option>
                                        {invoiceBranch.length > 0 &&
                                          invoiceBranch.map((_branch) => (
                                            <option
                                              key={`branchs-${_branch.value}`}
                                              value={_branch.value}
                                            >
                                              {_branch.label}
                                            </option>
                                          ))}
                                      </Input>
                                    </FormGroup>
                                    <FormGroup>
                                      <label className='f-w-600 label-report'>
                                        <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Periodo
                                      </label>
                                      <Input
                                        style={{
                                          borderColor: "#5bbfff",
                                          borderStyle: "solid",
                                          borderWidth: "1px",
                                          borderRadius: "15px",
                                          height: "35px",
                                          fontSize: "14px",
                                        }}
                                        type="select"
                                        onChange={(e) => handleSelectMonth(e.target.value)}
                                      >
                                        <option value={0}>Selecciona un periodo</option>
                                        {monthInvoices.length > 0 &&
                                          monthInvoices.map((_month) => (
                                            <option
                                              key={`monthIn-${_month.value}`}
                                              value={_month.value}
                                            >
                                              {_month.label}
                                            </option>
                                          ))}
                                      </Input>
                                    </FormGroup>
                                    <FormGroup>
                                      <label className='f-w-600 label-report'>
                                        <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Año
                                      </label>
                                      <Input
                                        style={{
                                          borderColor: "#5bbfff",
                                          borderStyle: "solid",
                                          borderWidth: "1px",
                                          borderRadius: "15px",
                                          height: "35px",
                                          fontSize: "14px",
                                        }}
                                        type="select"
                                        onChange={(e) => handleSelectAge(e.target.value)}
                                      >
                                        <option value={0}>Selecciona</option>
                                        <option value="2024">2024</option>
                                        <option value="2025">2025</option>
                                        <option value="2026">2026</option>
                                      </Input>
                                    </FormGroup>
                                    <FormGroup>
                                      <label className='f-w-600 label-report'>
                                        <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Metódo de pago
                                      </label>
                                      <select
                                        className="form-control"
                                        style={{
                                          borderColor: "#5bbfff",
                                          borderStyle: "solid",
                                          borderWidth: "1px",
                                          borderRadius: "15px",
                                          height: "35px",
                                          fontSize: "13px",
                                        }}
                                        onChange={(e) => setSelectedPaymentMethod(Number(e.target.value))}
                                      >
                                        <option value="">Todos</option>
                                        {Object.keys(paymentMethods).map((key) => (
                                          <option key={key} value={key}>
                                            {paymentMethods[key]}
                                          </option>
                                        ))}
                                      </select>
                                    </FormGroup>

                                    <b>Acciones</b>
                                    <br /><br />
                                    {
                                      activeView === 0 && <Button
                                        className="mb-3 w-100"
                                        style={{
                                          width: "100%",
                                          borderRadius: "10px",
                                          padding: "10px",
                                          fontSize: "14px",
                                          fontWeight: 600,
                                          backgroundColor: "#000",
                                          borderColor: "#000",
                                          color: "#fff",
                                          transition: "all .2s ease"
                                        }}
                                        onClick={() => getInformationInvoices2()}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.transform = "translateY(-2px)";
                                          e.currentTarget.style.backgroundColor = "#222";
                                          e.currentTarget.style.borderColor = "#222";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.transform = "translateY(0)";
                                          e.currentTarget.style.backgroundColor = "#000";
                                          e.currentTarget.style.borderColor = "#000";
                                        }}
                                      >
                                        {/* <i className="fa fa-search mr-2"></i> */}
                                        Buscar
                                      </Button>
                                    }
                                    {
                                      activeView === 1 && <Button
                                        className="mb-3 w-100"
                                        style={{
                                          width: "100%",
                                          borderRadius: "10px",
                                          padding: "10px",
                                          fontSize: "14px",
                                          fontWeight: 600,
                                          backgroundColor: "#000",
                                          borderColor: "#000",
                                          color: "#fff",
                                          transition: "all .2s ease"
                                        }}
                                        onClick={() => getInformationInvoices()}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.transform = "translateY(-2px)";
                                          e.currentTarget.style.backgroundColor = "#222";
                                          e.currentTarget.style.borderColor = "#222";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.transform = "translateY(0)";
                                          e.currentTarget.style.backgroundColor = "#000";
                                          e.currentTarget.style.borderColor = "#000";
                                        }}
                                      >
                                        {/* <i className="fa fa-search mr-2"></i> */}
                                        Buscar
                                      </Button>
                                    }
                                    {
                                      activeView === 1 && <Button
                                        className="mb-3 w-100"
                                        style={{
                                          width: "100%",
                                          borderRadius: "10px",
                                          padding: "10px",
                                          fontSize: "14px",
                                          fontWeight: 600,
                                          backgroundColor: "#000",
                                          borderColor: "#000",
                                          color: "#fff",
                                          transition: "all .2s ease"
                                        }}
                                        onClick={() => handleInvoices()}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.transform = "translateY(-2px)";
                                          e.currentTarget.style.backgroundColor = "#222";
                                          e.currentTarget.style.borderColor = "#222";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.transform = "translateY(0)";
                                          e.currentTarget.style.backgroundColor = "#000";
                                          e.currentTarget.style.borderColor = "#000";
                                        }}
                                      >
                                        {/* <i className="fa fa-search mr-2"></i> */}
                                        Liberar
                                      </Button>
                                    }

                                    <Button
                                      className="mb-3 w-100"
                                      style={{
                                        width: "100%",
                                        borderRadius: "10px",
                                        padding: "10px",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        backgroundColor: "#2581cd",
                                        borderColor: "#2581cd",
                                        color: "#fff",
                                        transition: "all .2s ease"
                                      }}
                                      onClick={() => requestChangeType(2)}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-2px)";
                                        e.currentTarget.style.backgroundColor = "#2581cd";
                                        e.currentTarget.style.borderColor = "#2581cd";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.backgroundColor = "#2581cd";
                                        e.currentTarget.style.borderColor = "#2581cd";
                                      }}
                                    >
                                      {/* <i className="fa fa-search mr-2"></i> */}
                                      Regresar
                                    </Button>




                                  </CardBody>


                                </Card>
                              </Col>
                              {
                                activeView === 0 && <Col sm="10">
                                  <div className="table-responsive ">
                                    <DataTable
                                      value={filteredInvoicess}
                                      paginator
                                      rows={10}
                                      className="data-table p-datatable-striped p-datatable-sm"
                                      emptyMessage={
                                        <div className="text-center">
                                          <img src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "40%" }} alt="Sin Cotizaciones" />
                                          <br />
                                          <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>No se encontraron resultados</p>
                                        </div>
                                      }
                                      loading={loadingPending}
                                      rowsPerPageOptions={[10, 50, 100]}
                                      responsiveLayout="scroll"
                                    >

                                      <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                                      <Column
                                        field="nimm"
                                        header="nim"
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                        body={(rowData) => (
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              gap: "8px"
                                            }}
                                          >
                                            <i
                                              className="fa fa-copy"
                                              title="Copiar código"
                                              // onClick={() => copyCode(rowData.code)}
                                              style={{
                                                //  cursor: "pointer",
                                                color: "#1d5b83",
                                                fontSize: "14px"
                                              }}
                                            />

                                            <span style={{ fontWeight: 700 }}>
                                              {rowData.nimm}
                                            </span>
                                          </div>
                                        )}
                                      />
                                      <Column field="fech" header="Fecha" body={(rowData) => (
                                        <span style={{ fontWeight: 600 }}>
                                          {rowData.fech}
                                        </span>
                                      )} sortable headerStyle={headerStyle} style={cellStyle} />
                                      <Column
                                        field="branch"
                                        header="Sucursal"
                                        sortable
                                        headerStyle={headerStyle}
                                        style={{
                                          ...cellStyle,
                                          minWidth: "220px",
                                          maxWidth: "250px"
                                        }}
                                        body={(rowData) => {
                                          const branch = getBranchStyle(rowData.id_brach);

                                          return (
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center"
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                  padding: "6px 10px",
                                                  borderRadius: "20px",
                                                  background: branch.background,
                                                  color: branch.color,
                                                  border: `1px solid ${branch.color}`,
                                                  fontWeight: 600,
                                                  maxWidth: "100%",
                                                  whiteSpace: "normal",
                                                  wordBreak: "break-word",
                                                  textAlign: "center"
                                                }}
                                              >
                                                <i className={branch.icon} style={{ flexShrink: 0 }} />
                                                <span>{rowData.branch}</span>
                                              </span>
                                            </div>
                                          );
                                        }}
                                      />

                                      <Column
                                        field="name"
                                        header="Paciente"
                                        headerStyle={headerStyle}
                                        style={{
                                          ...cellStyle,
                                          minWidth: "240px",
                                          maxWidth: "300px"
                                        }}
                                        body={(rowData) => (
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "center"
                                            }}
                                          >
                                            <span
                                              title={rowData.name}
                                              style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: "8px",
                                                maxWidth: "100%",
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                                textAlign: "left",
                                                fontWeight: 700
                                              }}
                                            >
                                              <i
                                                className="fa fa-user"
                                                style={{
                                                  color: "#1d5b83",
                                                  fontSize: "14px",
                                                  flexShrink: 0
                                                }}
                                              />

                                              <span>{rowData.name}</span>
                                            </span>
                                          </div>
                                        )}
                                      />

                                      <Column
                                        header="Método de pago"
                                        headerStyle={headerStyle}
                                        style={{
                                          ...cellStyle,
                                          minWidth: "220px",
                                          maxWidth: "260px"
                                        }}
                                        body={(rowData) => (
                                          <div
                                            style={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              gap: "6px",
                                              justifyContent: "center"
                                            }}
                                          >
                                            {rowData.pay_methods.map((id) => {
                                              const pay = getPayMethodInfo(id);

                                              return (
                                                <span
                                                  key={id}
                                                  title={pay.name}
                                                  style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: "6px",
                                                    padding: "5px 10px",
                                                    borderRadius: "18px",
                                                    background: pay.background,
                                                    color: pay.color,
                                                    border: `1px solid ${pay.color}`,
                                                    fontWeight: 600,
                                                    fontSize: "12px",
                                                    maxWidth: "100%",
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-word",
                                                    textAlign: "center"
                                                  }}
                                                >
                                                  <i
                                                    className={pay.icon}
                                                    style={{ flexShrink: 0 }}
                                                  ></i>

                                                  <span>{pay.name}</span>
                                                </span>
                                              );
                                            })}
                                          </div>
                                        )}
                                      />
                                      <Column
                                        header="Requiere F."
                                        headerStyle={{
                                          ...headerStyle,
                                          width: "70px",
                                          textAlign: "center"
                                        }}
                                        style={{
                                          ...cellStyle,
                                          width: "70px",
                                          minWidth: "70px",
                                          maxWidth: "70px",
                                          textAlign: "center"
                                        }}
                                        body={(rowData) => (
                                          <i
                                            className={
                                              rowData.requiere_invoices
                                                ? "fa fa-check-circle"
                                                : "fa fa-times-circle"
                                            }
                                            style={{
                                              fontSize: "18px",
                                              color: rowData.requiere_invoices ? "#2e7d32" : "#d32f2f"
                                            }}
                                          />
                                        )}
                                      />




                                    </DataTable>
                                  </div>
                                </Col>
                              }
                              {
                                activeView === 1 && <Col sm="10">
                                  <div className='table-responsive' >
                                    <DataTable
                                      value={filteredInvoices}
                                      paginator
                                      rows={10}
                                      rowsPerPageOptions={[10, 50, 100]}
                                      className="data-table p-datatable-striped p-datatable-sm"
                                      responsiveLayout="scroll"
                                      loading={loadingInvoice}
                                      emptyMessage={
                                        <div className="text-center">
                                          <img
                                            src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                            style={{ width: "25%" }}
                                            alt="Sin resultados"
                                          />
                                          <br />
                                          <p className='badge badge-light-primary mt-2'>
                                            Sin información disponible.
                                          </p>
                                        </div>
                                      }
                                    >

                                      {/* NUMERO */}
                                      <Column
                                        body={(rowData, { rowIndex }) => rowIndex + 1}
                                        header="#"
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                      />


                                      {/* CHECKBOX */}
                                      <Column
                                        header={
                                          <input
                                            type="checkbox"
                                            checked={selectAll}
                                            onChange={handleSelectAllChange}
                                            style={{
                                              cursor: "pointer",
                                              width: "18px",
                                              height: "18px"
                                            }}
                                          />
                                        }
                                        body={(rowData) => {

                                          const idWorkOrder = rowData.id_work_order;
                                          const checked = !!checkedItems[idWorkOrder];


                                          return (
                                            <div style={{ textAlign: "center" }}>

                                              <input
                                                type="checkbox"
                                                id={`checkbox-${idWorkOrder}`}
                                                checked={checked}
                                                onChange={() =>
                                                  handleCheckboxChange(idWorkOrder)
                                                }
                                                style={{
                                                  display: "none"
                                                }}
                                              />

                                              <label
                                                htmlFor={`checkbox-${idWorkOrder}`}
                                                style={{
                                                  display: "inline-block",
                                                  width: "20px",
                                                  height: "20px",
                                                  borderRadius: "50%",
                                                  border: "2px solid #065c88",
                                                  cursor: "pointer",
                                                  position: "relative"
                                                }}
                                              >

                                                <span
                                                  style={{
                                                    position: "absolute",
                                                    top: "50%",
                                                    left: "50%",
                                                    width: "12px",
                                                    height: "12px",
                                                    background: "#065c88",
                                                    borderRadius: "50%",
                                                    transform: "translate(-50%,-50%)",
                                                    opacity: checked ? 1 : 0,
                                                    transition: "0.2s"
                                                  }}
                                                />

                                              </label>

                                            </div>
                                          )
                                        }}
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                      />


                                      {/* NIM */}
                                      <Column
                                        field="nimm"
                                        header="Nim"
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                        body={(rowData) => (
                                          <span
                                            style={{
                                              fontWeight: 700,
                                              color: "#6c757d"
                                            }}
                                          >
                                            {rowData.nimm}
                                          </span>
                                        )}
                                      />


                                      {/* NOMBRE */}
                                      <Column
                                        field="name"
                                        header="Nombre"
                                        headerStyle={headerStyle}
                                        style={{
                                          ...cellStyle,
                                          minWidth: "240px"
                                        }}
                                        body={(rowData) => (
                                          <div>
                                            <i
                                              className="fa fa-user"
                                              style={{
                                                color: "#1d5b83",
                                                marginRight: "8px"
                                              }}
                                            />

                                            <b style={{
                                              color: "#1e73a9"
                                            }}>
                                              {rowData.name}
                                            </b>
                                          </div>
                                        )}
                                      />


                                      <Column
                                        field="branch"
                                        header="Sucursal"
                                        sortable
                                        headerStyle={headerStyle}
                                        style={{
                                          ...cellStyle,
                                          minWidth: "220px",
                                          maxWidth: "250px"
                                        }}
                                        body={(rowData) => {
                                          const branch = getBranchStyle(rowData.id_brach);

                                          return (
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center"
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                  padding: "6px 10px",
                                                  borderRadius: "20px",
                                                  background: branch.background,
                                                  color: branch.color,
                                                  border: `1px solid ${branch.color}`,
                                                  fontWeight: 600,
                                                  maxWidth: "100%",
                                                  whiteSpace: "normal",
                                                  wordBreak: "break-word",
                                                  textAlign: "center"
                                                }}
                                              >
                                                <i className={branch.icon} style={{ flexShrink: 0 }} />
                                                <span>{rowData.branch}</span>
                                              </span>
                                            </div>
                                          );
                                        }}
                                      />


                                      {/* FECHA */}
                                      <Column
                                        field="fech"
                                        header="Fecha"
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                      />


                                      {/* FACTURA */}
                                      <Column
                                        header="Solicito factura"
                                        headerStyle={headerStyle}
                                        style={{
                                          ...cellStyle,
                                          textAlign: "center"
                                        }}
                                        body={(rowData) => (
                                          rowData.invoices
                                            ?
                                            <i className="fa fa-check txt-success f-14"></i>
                                            :
                                            <i className="fa fa-times-circle text-danger"></i>
                                        )}
                                      />


                                      {/* METODO PAGO */}
                                      <Column
                                        header="Método de pago"
                                        headerStyle={headerStyle}
                                        style={{
                                          ...cellStyle,
                                          minWidth: "220px"
                                        }}
                                        body={(rowData) => (
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "5px",
                                              flexWrap: "wrap"
                                            }}
                                          >

                                            {
                                              rowData.pay_methods?.map(id => {

                                                const pay = getPayMethodInfo(id);

                                                return (
                                                  <span
                                                    key={id}
                                                    style={{
                                                      padding: "5px 10px",
                                                      borderRadius: "18px",
                                                      background: pay.background,
                                                      color: pay.color,
                                                      border: `1px solid ${pay.color}`,
                                                      fontSize: "12px",
                                                      fontWeight: 600
                                                    }}
                                                  >
                                                    <i className={pay.icon}></i>{" "}
                                                    {pay.name}
                                                  </span>
                                                )

                                              })
                                            }

                                          </div>
                                        )}
                                      />


                                      {/* TOTAL */}
                                      <Column
                                        header="Total"
                                        headerStyle={headerStyle}
                                        style={{
                                          ...cellStyle,
                                          textAlign: "right"
                                        }}
                                        body={(rowData) => (
                                          <b>
                                            ${number_format(rowData.amount ?? 0, 2)}
                                          </b>
                                        )}
                                      />


                                    </DataTable>

                                  </div>
                                </Col>

                              }

                            </Row>
                          </Col>


                        </div>


                      </div>

                    </div>












                  </Col>

                )
              }
            </Card >


          </Col >
        </div >
      }
    </Fragment >
  )
}